export const FETCH_EXAM_RESULT = 'FETCH_EXAM_RESULT'
export const FETCH_EXAM_RESULT_SUCCESS = 'FETCH_EXAM_RESULT_SUCCESS'
export const FETCH_EXAM_RESULT_FAILURE = 'FETCH_EXAM_RESULT_FAILURE'

export const SAVE_EXAM_RESULT = 'SAVE_EXAM_RESULT'
export const SAVE_EXAM_RESULT_SUCCESS = 'SAVE_EXAM_RESULT_SUCCESS'
export const SAVE_EXAM_RESULT_FAILURE = 'SAVE_EXAM_RESULT_FAILURE'

export const DELETE_EXAM_RESULT = 'DELETE_EXAM_RESULT'
export const DELETE_EXAM_RESULT_SUCCESS = 'DELETE_EXAM_RESULT_SUCCESS'
export const DELETE_EXAM_RESULT_FAILURE = 'DELETE_EXAM_RESULT_FAILURE'
